import Embla from "embla-carousel";
import { setupDotBtns, generateDotBtns, selectDotBtn } from "./carousel-dots";

// const document = null;

let archiveActiveStepIndex = 0;
const archiveActiveStepIndexElement = document.querySelector('.archive-steps__step--active');

if(archiveActiveStepIndexElement) {
    archiveActiveStepIndex = Number(archiveActiveStepIndexElement.dataset.index)
}

const carouselOptions = {
    draggable: true,
    align: "start",
    containScroll: "keepSnaps",
};

const carousel = {
    // align: "start",
    slidesToScroll: 1,
    // skipsSnaps: false,
    containScroll: "keepSnaps",
    dragFree: true,
    startIndex: archiveActiveStepIndex
};


const emblaCards = document.querySelector(".card-carousel");
const emblaSteps = document.querySelector(".archive-stepper");

if(emblaCards){
    const dotsNode = emblaCards.querySelector(".embla__dots");
    const embla = Embla(emblaCards, carouselOptions);
    const dotNodesArray = generateDotBtns(dotsNode, embla);
    setupDotBtns(dotNodesArray, embla);
    
    const selectDotButtons = selectDotBtn(dotNodesArray, embla);
    embla.on("select", selectDotButtons);
    embla.on("init", selectDotButtons);
}


if(emblaSteps){
    Embla(emblaSteps, carousel);
}






